// src/presentation/components/layout/Sidebar.tsx
import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './Sidebar.css'

interface NavItem {
  to: string
  icon: string
  label: string
}

const navItems: NavItem[] = [
  // { to: '/dashboard', icon: '/icons/dashboard-icon.svg', label: 'Dashboard' },
  { to: '/inventory', icon: '/icons/inventory-icon.svg', label: 'Inventory' },
  { to: '/campaign', icon: '/icons/campaign-icon.svg', label: 'Campaigns' },
  { to: '/reports', icon: '/icons/reports-icon.svg', label: 'Reports' },
]

export const Sidebar: React.FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <nav className="sidebar">
      <ul>
        {navItems.map(({ to, icon, label }) => {
          const active = pathname === to
          return (
            <li
              key={to}
              className={`nav-item${active ? ' active' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => navigate(to)}
              onKeyDown={(e) =>
                (e.key === 'Enter' || e.key === ' ') && navigate(to)
              }
            >
              <img src={icon} alt={label} />
              <span>{label}</span>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
